var map = {
	"./address-tracker.png": 7652,
	"./authentication.png": 5122,
	"./bankist-users.png": 798,
	"./bankist.png": 9789,
	"./calculator.png": 8965,
	"./expense-tracker.png": 3233,
	"./expense.jpg": 8900,
	"./feedback-app.png": 6811,
	"./food-recipes.png": 2250,
	"./forkify.png": 9508,
	"./geuss-number.png": 3155,
	"./github-finder.png": 6198,
	"./happy-new-year.png": 355,
	"./mapty.png": 6237,
	"./matching-game.png": 7331,
	"./mobile.png": 8630,
	"./nintendo.png": 4102,
	"./omnifood.png": 4556,
	"./pig.png": 4616,
	"./sneakers.png": 4579,
	"./tic-tac-toe.png": 2630,
	"./weather-app.png": 449
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6757;